import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2fsrwhi2m7: FaireBrandEntity = {
  token: "b_2fsrwhi2m7",
  type: "brand",
  name: "JanMichaels Art & Home",
  location: "Elizabethtown, PA, USA",
  isTopShop: true,
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
